<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="center mgb-20px">
          <div class="columns">
            <div class="column">
              <h1 class="title is-size-4">
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.title') }}
              </h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <error-msg-component :messages="messages"
                               :messagesChampsVide="messagesChampsVide"
                               :champsVide="champsVide"
                               :error="error"
                               :title="'addEditCivilite.error.problemOccurred'"
                               :withEmplyFields="true"
                               @close="error = $event"/>
          <div class="columns">
            <b-field class="column is-3"
            :label="$t('listeEcheancePaiement.popUpCreationRemiseBancaire.nom')">
              <qd-switch v-model="isNomAutomatique"></qd-switch>
              <label>
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.nomAutomatique')}}
              </label>
            </b-field>
            <b-field class="column is-4 mgt-25px">
              <b-input v-model="nom" :disabled="isNomAutomatique"></b-input>
            </b-field>
            <b-field :label="$t('listeEcheancePaiement.popUpCreationRemiseBancaire.dateRemise')"
                      class="obligatoire column is-5">
              <div class="column is-12 is-paddingless">
                <div class="columns">
                  <b-datepicker show-week-number
                              icon="calendar-today"
                              :editable="true"
                              position="is-bottom-left"
                              v-model="dateRemise"
                              class="column is-12"
                              :nearby-selectable-month-days="true">
                  </b-datepicker>
                </div>
              </div>
            </b-field>
          </div>
          <div class="min-height200">
            <table class="VueTables__table table is-bordered is-striped full-width">
              <thead>
              <th class="colonne-responsive">
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.modeReglement') }}
              </th>
              <th class="colonne-responsive">
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.nombreReglement') }}
              </th>
              <th class="colonne-responsive">
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.montantRemise')}}
              </th>
              <th class="colonne-responsive">
                {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.montantResteAPayer')}}
              </th>
              <th class="colonne-responsive obligatoire">
                <span>{{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.banque')}}</span>
              </th>
              </thead>
              <tbody>
              <tr v-for="(item, index) in infosPaiements"
                  :key="index">
                <td class="colonne-responsive vertical-alignment">
                  {{ getLibelleModeReglement(item.modeReglementId) }}
                </td>
                <td class="colonne-responsive has-text-centered vertical-alignment">
                  {{ getNombreReglement(item.modeReglementId) }}
                </td>
                <td class="colonne-responsive has-text-right" vertical-alignment>
                  {{ func.formatDevise(getMontantByModeReglement(item.modeReglementId)) }}
                </td>
                <td class="colonne-responsive has-text-right" vertical-alignment>
                  {{ func.formatDevise(getResteAPayerByModeReglement(item.modeReglementId)) }}
                </td>
                <td class="colonne-responsive">
                  <b-select v-model="item.domiciliationBancaireId" expanded>
                    <option v-for="domiciliation in loadDomiciliationBancaire"
                            :value="domiciliation.id" :key="domiciliation.id">
                      {{ `${domiciliation.libelle} - ${domiciliation.libelleBanque}` }}
                    </option>
                  </b-select>
                </td>
              </tr>
              <tr v-if="getAllModeReglement.length > 1">
                <td class="colonne-responsive has-text-weight-bold">
                </td>
                <td class="colonne-responsive has-text-centered has-text-weight-bold">
                  {{ nombreReglementTotal }}
                </td>
                <td class="colonne-responsive has-text-right has-text-weight-bold">
                  {{ func.formatDevise(montantTotal) }}
                </td>
                <td class="colonne-responsive has-text-weight-bold">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <b-checkbox v-model="redirection" class="mgt-15px">
            {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.actions.redirection') }}
          </b-checkbox>
          <footer class="mgt-15px">
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.actions.cancel')}}
                </a>
              </div>
              <div class="is-pulled-left boutonAction">
                <a class="button is-addOrEdit" @click="createRemiseBancaire">
                  {{ $t('listeEcheancePaiement.popUpCreationRemiseBancaire.actions.create')}}
                </a>
              </div>
            </b-field>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { generationRemiseBancaire } from '@/api/echeancePaiement/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import validation from '@/services/validation/validation';
import translate from '@/services/echeancePaiement/translatorEcheancePaiement';
import messageErreur from '@/services/general/messageErreur';
import { formatDevise } from '@/services/general/filters/formatDevise';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationEcheancePaiement from '@/services/echeancePaiement/validationEcheancePaiement';
import messageSuccess from '@/services/general/messageSucces';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_creationRemiseBancaire',
  props: {
    echeances: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      redirection: true,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      dateRemise: new Date(),
      nom: null,
      infosPaiements: [],
      exerciceOk: true,
      errorsExercice: '',
      isNomAutomatique: true,
      func: {
        formatDevise,
      },
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getMontantByModeReglement(modeReglementId) {
      const montant = this.echeances
        .filter((echeance) => { return echeance.modeReglementId === modeReglementId; })
        .map((echeance) => {
          return echeance.montantTTC;
        })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
      return montant;
    },
    getResteAPayerByModeReglement(modeReglementId) {
      return this.echeances
        .filter((echeance) => echeance.modeReglementId === modeReglementId)
        .reduce((acc, ech) => acc + ech.resteALettrer, 0);
    },
    getNombreReglement(modeReglementId) {
      const echeances = this.echeances
        .filter((echeance) => { return echeance.modeReglementId === modeReglementId; });
      const reglement = [...new Set(echeances.map((el) => {
        return el.id;
      }))];
      return reglement.length;
    },
    async createRemiseBancaire() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const remisesBancaires = [];
        let remiseBancaire = null;
        this.infosPaiements.forEach((paiement) => {
          const infoRemise = {
            echeancePaiementIds: this.echeances.filter((el) => {
              return el.modeReglementId === paiement.modeReglementId;
            }).map((el) => { return el.id; }),
            domiciliationBancaireId: paiement.domiciliationBancaireId,
          };
          remisesBancaires.push(infoRemise);
        });
        const param = {
          remisesBancaires,
          dateRemise: formatIsoDate(this.dateRemise),
          nom: this.nom,
        };
        remiseBancaire = (await generationRemiseBancaire(param)).data.result;
        loadingComponent.close();
        messageSuccess(this.$i18n.t('listeEcheancePaiement.popUpCreationRemiseBancaire.success.creationRemiseBancaire'));
        if (this.redirection && remiseBancaire.length > 1) await this.$router.push({ name: 'l.bodac.remises_bancaires' });
        else if (this.redirection && remiseBancaire.length === 1) await this.$router.push({ name: 'c.bodac.remises_bancaires', params: { id: remiseBancaire[0].id } });
        else this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationEcheancePaiement(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getLibelleModeReglement(modeReglementId) {
      const modeReglementFind = this.modesReglement.find((modeReglement) => {
        return modeReglement.id === modeReglementId;
      });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
    setInformationsPaiement() {
      const modesReglementsIds = [...new Set(this.echeances.map(d => d.modeReglementId))];
      modesReglementsIds.forEach((modeId) => {
        this.infosPaiements.push({
          modeReglementId: modeId,
          domiciliationBancaireId: null,
        });
      });
    },
  },
  computed: {
    getAllModeReglement() {
      return [...new Set(this.echeances.map(d => d.modeReglementId))];
    },
    nombreReglementTotal() {
      let total = 0;
      const modeReglement = this.getAllModeReglement;
      modeReglement.forEach((modeReglement) => {
        total += this.getNombreReglement(modeReglement);
      });
      return total;
    },
    montantTotal() {
      let total = 0;
      const modeReglement = this.getAllModeReglement;
      modeReglement.forEach((modeReglement) => {
        total += this.getMontantByModeReglement(modeReglement);
      });
      return total;
    },
    modesReglement() {
      const modesReglement = this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
      return modesReglement;
    },
    loadDomiciliationBancaire() {
      const domBancairesIds = this.parametre(
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ).filter((domicialisation) => {
        return domicialisation.actif;
      });

      if (domBancairesIds.length === 1) {
        this.infosPaiements.forEach(infos => {
          infos.domiciliationBancaireId = domBancairesIds[0].id;
        });
      }
      return domBancairesIds;
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      this.setInformationsPaiement();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
